import { Injectable, Provider } from '@angular/core';
import { EQuantityValidationResult } from '../../../enum/quantity/quantity-validation-result.enum';
import { QuantityInputBareChangeResult } from '../../../components/shared/base/quantity-input/quantity-input-bare/change-result/quantity-input-bare-change-result.model';
import { IQuantityValidationService, IQuantityValidationServiceToken } from './quantity-validation-service.interface';

@Injectable({
  providedIn: 'root'
})
export class QuantityValidationService implements IQuantityValidationService {

  public validateQuantity(quantity: number, minimumOrderAmount: number, maximumOrderAmount: number): QuantityInputBareChangeResult {
    let quantityChangeResult = new QuantityInputBareChangeResult();
    quantityChangeResult.validationResult = EQuantityValidationResult.Unvalidated;
    let maximumQuotient = Math.floor(maximumOrderAmount / minimumOrderAmount);

    // below minimum
    if (quantity < minimumOrderAmount) {
      quantityChangeResult.validationResult = EQuantityValidationResult.BelowMinium;
      quantityChangeResult.valueCurrent = minimumOrderAmount;
      return quantityChangeResult;
    }

    // between min-max
    let quotient = Math.round(quantity / minimumOrderAmount);
    let remainder = this.calculateRemainder(quantity, minimumOrderAmount);

    if (remainder > 0) {
      quotient++;
    }

    quantity = minimumOrderAmount * quotient;

    if (quantity % minimumOrderAmount !== 0) {
      // Extrahiere die Anzahl der Dezimalstellen von minimumOrderAmount
      let decimalPlaces = minimumOrderAmount.toString().split('.')[1]?.length || 0;
      quantity = Number(quantity.toFixed(decimalPlaces));
    }

    // above maximum
    if (quantity > maximumOrderAmount) {
      quantityChangeResult.validationResult = EQuantityValidationResult.AboveMaximum;
      quantityChangeResult.valueCurrent = minimumOrderAmount * maximumQuotient;
      return quantityChangeResult;
    }

    quantityChangeResult.validationResult = EQuantityValidationResult.Valid;
    quantityChangeResult.valueCurrent = quantity;
    return quantityChangeResult;
  }

  private calculateRemainder(quantity: number, minimumOrderAmount: number): number {
    let factor = 10 ** 6;

    let intValue = Math.round(quantity * factor);
    let intMinimumOrderAmount = Math.round(minimumOrderAmount * factor);
    let remainderInt = intValue % intMinimumOrderAmount;

    return remainderInt / factor;
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const QuantityValidationServiceProvider: Provider =
  { provide: IQuantityValidationServiceToken, useExisting: QuantityValidationService };
